export default __webpack_public_path__ + "static/media/grey.9e38ddd4.ogg";